/**
 * @flow
 * @relayHash f409a2f8f94eb48426f61eb792e21aa1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PackageTrackerAddressConfirmationMutationInput = {|
  packageId: number,
  isAddressCorrect?: ?boolean,
  clientMutationId?: ?string,
|};
export type confirmOriginalAddressMutationVariables = {|
  input: PackageTrackerAddressConfirmationMutationInput
|};
export type confirmOriginalAddressMutationResponse = {|
  +packageTrackerAddressConfirmation: ?{|
    +success: ?boolean
  |}
|};
export type confirmOriginalAddressMutation = {|
  variables: confirmOriginalAddressMutationVariables,
  response: confirmOriginalAddressMutationResponse,
|};
*/

/*
mutation confirmOriginalAddressMutation(
  $input: PackageTrackerAddressConfirmationMutationInput!
) {
  packageTrackerAddressConfirmation(input: $input) {
    success
  }
}
*/

const node /*: ConcreteRequest*/ = (function() {
  var v0 = [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'PackageTrackerAddressConfirmationMutationInput!',
        defaultValue: null
      }
    ],
    v1 = [
      {
        kind: 'LinkedField',
        alias: null,
        name: 'packageTrackerAddressConfirmation',
        storageKey: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input'
          }
        ],
        concreteType: 'PackageTrackerAddressConfirmationMutation',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            name: 'success',
            args: null,
            storageKey: null
          }
        ]
      }
    ];
  return {
    kind: 'Request',
    fragment: {
      kind: 'Fragment',
      name: 'confirmOriginalAddressMutation',
      type: 'Mutation',
      metadata: null,
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    operation: {
      kind: 'Operation',
      name: 'confirmOriginalAddressMutation',
      argumentDefinitions: (v0 /*: any*/),
      selections: (v1 /*: any*/)
    },
    params: {
      operationKind: 'mutation',
      name: 'confirmOriginalAddressMutation',
      id: null,
      text:
        'mutation confirmOriginalAddressMutation(\n  $input: PackageTrackerAddressConfirmationMutationInput!\n) {\n  packageTrackerAddressConfirmation(input: $input) {\n    success\n  }\n}\n',
      metadata: {}
    }
  };
})();
// prettier-ignore
(node/*: any*/).hash = '5b54bbe2de9cad0001a590812897755d';
module.exports = node;
